/**
 * Results Progress Circles — Web Component
 * Animates SVG stroke-dashoffset and counter text on scroll into viewport.
 * Respects prefers-reduced-motion.
 */
if (!customElements.get('results-progress')) {
  class ResultsProgress extends HTMLElement {
    connectedCallback() {
      this.animated = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.prefersReducedMotion) {
        this.showFinalState();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animated) {
              this.animated = true;
              this.animate();
              this.observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    showFinalState() {
      this.querySelectorAll('[data-progress-circle]').forEach((circle) => {
        const track = circle.querySelector('[data-track]');
        const counter = circle.querySelector('[data-counter]');
        const targetOffset = parseFloat(track.dataset.targetOffset);
        const value = track.dataset.value;

        track.style.strokeDashoffset = targetOffset;
        if (counter) counter.textContent = value;
      });
    }

    animate() {
      const duration = 1200;
      const circles = this.querySelectorAll('[data-progress-circle]');

      circles.forEach((circle) => {
        const track = circle.querySelector('[data-track]');
        const counter = circle.querySelector('[data-counter]');
        const circumference = parseFloat(track.dataset.circumference);
        const targetOffset = parseFloat(track.dataset.targetOffset);
        const rawValue = track.dataset.value;
        const isDecimal = rawValue.includes('.');
        const numericValue = parseFloat(rawValue);

        const startOffset = circumference;
        const startTime = performance.now();

        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);

          const currentOffset = startOffset + (targetOffset - startOffset) * eased;
          track.style.strokeDashoffset = currentOffset;

          if (counter) {
            const currentValue = numericValue * eased;
            counter.textContent = isDecimal
              ? currentValue.toFixed(1)
              : Math.round(currentValue);
          }

          if (progress < 1) {
            requestAnimationFrame(step);
          }
        };

        requestAnimationFrame(step);
      });
    }
  }

  customElements.define('results-progress', ResultsProgress);
}
